mpangoApp.directive('donutChart', function() {
  // function link(scope, el, attr){
  //   var color = d3.scale.ordinal().range(["#bd9e39","#0868ac"]);
  //   var data = scope.data;
  //   var width = 150;
  //   var height = 150;
  //   var min = Math.min(width, height);
  //   var svg = d3.select(el[0]).append('svg');
  //   var pie = d3.layout.pie().sort(null);
  //   var arc = d3.svg.arc();
  //   arc.outerRadius(min / 2 * 0.8)
  //     .innerRadius(min / 2 * 0.45);
  //   pie.value(function(d){ return +d.value ; });
  //   svg.attr({width: width, height: height});
  //   var g = svg.append('g')
  //     .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  //   var arcs = g.selectAll('path').data(pie(data))
  //     .enter().append('path')
  //     .style('stroke', 'white')
  //     .attr('fill-opacity', 0.75)
  //     .attr('fill', function(d, i){ return color(i); })
  //     .each(function(d) { return this._current = d });
  //   var labels = g.selectAll('.label').data(pie(data))
  //     .enter().append("text")
  //     .attr("transform", function(d) { return "translate(" + arc.centroid(d) + ")"; })
  //     .attr("dy", ".35em")
  //     .attr("class", "label")
  //     .style("text-anchor", "middle")
  //     .text(function(d) { return d.data.label; });
  //     scope.$watch('data', function (newVal, oldVal) {
  //       console.log("an element within `data` changed!");
  //       var ca = newVal.filter(function(d) {return d.label === "CA-Residents";}),
  //           nr = newVal.filter(function(d) {return d.label === "Non-Residents";}),
  //           duration = 750;
  //           nr[0].value = +nr[0].value;
  //       ca[0].value = 100 - nr[0].value;
  //       arcs.data(pie(scope.data)); //.attr('d', arc)
  //       arcs.transition().duration(duration).attrTween('d', arcTween);
  //       labels.data(pie(scope.data)).transition().duration(duration).attr("transform", function(d) { return "translate(" + arc.centroid(d) + ")"; });
  //     }, true);        
  // }
  function link(scope, el, attr){
    var cala = scope.cala;
    var cala1 = scope.cala1;
    // var color = d3.scale.category10();
    var color = d3.scale.ordinal().range([cala,cala1]);
    var width = 100;
    var height = 100;
    var min = Math.min(width, height);
    var svg = d3.select(el[0]).append('svg');
    var pie = d3.layout.pie().sort(null);
    var arc = d3.svg.arc()
      .outerRadius(min / 2 * 0.9)
      .innerRadius(min / 2 * 0.5);
    // var data = scope.data;
    svg.attr({width: width, height: height});

    // center the donut chart
    var g = svg.append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
    
    // add the <path>s for each arc slice
    var arcs = g.selectAll('path');
    var labels = g.selectAll('.label');
    scope.$watch('data', function(data){
      if(!data){ return; }
      arcs = arcs.data(pie(data.series));
      arcs.exit().remove();
      arcs.enter().append('path')
        .style('stroke', 'white')
        .attr('fill', function(d, i){ return color(i) });
      arcs.attr('d', arc);
      // labels = labels.data(pie(data.label));
      // labels.exit().remove();
      // labels.enter().append("text")
      // .attr("transform", function(d) { return "translate(" + arc.centroid(d) + ")"; })
      // .attr("dy", ".35em")
      // .attr("class", "label")
      // .style("text-anchor", "middle")
      // .text(function(d) { return d.data.label; });
    }, true);
  }
  return {
    link: link,
    restrict: 'EA',
    scope: { 'data': '=','cala':'=','cala1':'='}
  };
  function arcTween(a) {
    var i = d3.interpolate(this._current, a);
      this._current = i(0);
      return function(t) {
        return arc(i(t));
      };
  }
});